import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  LinearProgress,
  Chip,
} from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

interface AuthorsTableProps {
  stats: ChatAnalyze.Stats
}

export function AuthorsTable({ stats }: AuthorsTableProps) {
  const { topUsers = [], top5Share } = stats

  const top5Cls =
    top5Share < 0.5 ? "success" : top5Share < 0.7 ? "warning" : "error"
  const top5Label =
    top5Share < 0.5
      ? "норма"
      : top5Share < 0.7
        ? "умеренная концентрация"
        : "высокая концентрация"

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography variant="body2">
          Топ-5 авторов пишут <strong>{(top5Share * 100).toFixed(1)}%</strong>{" "}
          всех сообщений
        </Typography>
        <Chip
          label={top5Label}
          size="small"
          color={top5Cls as "success" | "warning" | "error"}
        />
      </Box>

      <TableContainer sx={{ maxHeight: 440 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700, width: 40 }}>#</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Имя</TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: "text.secondary",
                  fontSize: "0.75rem",
                }}
              >
                ID
              </TableCell>
              <TableCell sx={{ fontWeight: 700 }} align="right">
                Сообщ.
              </TableCell>
              <TableCell sx={{ fontWeight: 700, minWidth: 180 }}>
                Доля
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {topUsers.map((user, idx) => (
              <TableRow
                key={user.uid}
                sx={{
                  opacity: user.isBot ? 0.65 : 1,
                  "&:last-child td": { border: 0 },
                }}
              >
                <TableCell>{idx + 1}</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Typography component="span" sx={{ fontSize: "1em" }}>
                      {user.isBot ? "🤖" : "👤"}
                    </Typography>
                    <Typography
                      variant="body2"
                      color={user.isBot ? "text.disabled" : "text.primary"}
                      noWrap
                      sx={{ maxWidth: 200 }}
                    >
                      {user.name}
                    </Typography>
                    {user.share > 0.2 && (
                      <Typography component="span" title="Доминирующий автор">
                        ⚠️
                      </Typography>
                    )}
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {user.uid}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <strong>{user.count.toLocaleString("ru-RU")}</strong>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <LinearProgress
                      variant="determinate"
                      value={user.share * 100}
                      color="secondary"
                      sx={{ flexGrow: 1, height: 6, borderRadius: 1 }}
                    />
                    <Typography variant="caption" sx={{ minWidth: 40 }}>
                      {(user.share * 100).toFixed(1)}%
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
